import * as React from 'react';
import { ButtonBase, ButtonProps } from '@mui/material';
import { Trans } from 'react-i18next';

export interface Props extends ButtonProps {
	enabled?: boolean
}

export default class GridButton extends React.Component<Props> {
	render() {
		const { enabled, ...otherProps} = this.props;
		const visibility = enabled ? "" : "disabled";
		const iconName = enabled ? "grid_on_blue" : "grid_on";
		const bgColor = enabled ? " blue-bg " : " grey-bg ";
		return <ButtonBase style={ {borderRadius: '30px', margin: '3px'} } >
			<div onClick={(e:React.MouseEvent) => this.props.onClick(e)} className={"action-buttons-icon-circular " + bgColor + visibility} >
				<hr className="cross-line"/>
				<img src={"static/img/icons/" + iconName + "-icon.svg"} alt="" width="25" height="25" />
			</div>
		</ButtonBase>
	}
}